"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    copackAgreement: 'Copack-avtal' || 'copackAgreement',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    name: 'Namn' || 'name',
    startDate: 'Startdatum' || 'startDate',
    articleFilter: 'Artikelfilter' || 'articleFilter',
    serviceAgreement: 'Serviceavtal' || 'serviceAgreement',
    serviceAgreements: {
        'v2.5': 'v2.5 - minimum serviceavgift  - Använder order och reklamationer' ||
            'v2.5',
        v3: 'v3' || 'v3',
        articlesOwnedByFlaivy: 'Flaivy äger alla produkterna pã denna organisation' ||
            'articlesOwnedByFlaivy',
    },
    supplierCommission: 'Marginal på leverantörsorder(%)' || 'supplierCommission',
    customerCommission: 'Marginal på weborder(%)' || 'customerCommission',
    salesCommission: 'Marginal på internorder (%)' || 'salesCommission',
    environmentFee: 'Miljöavgift' || 'environmentFee',
    purchaseOrderPriceExacta: 'Kostnad inleverans Exacta (per artikel per pall)' ||
        'purchaseOrderPriceExacta',
    purchaseOrderPriceVinden: 'Kostnad inleverans Vinden (per artikel per pall)' ||
        'purchaseOrderPriceVinden',
    monthlyBaseFee: 'Basavgift per månad' || 'monthlyBaseFee',
    monthlyExcessFee: 'Månadsavgift per extra 10 artiklar' || 'monthlyExcessFee',
    thresholdForEnvironmentFee: 'Gränsvärde för miljöavgift' || 'thresholdForEnvironmentFee',
    systembolagetCommission: 'Marginal på systembolag order (%)' || 'systembolagetCommission',
    stockfillerCommission: 'Marginal på stockfiller order (%)' || 'stockfillerCommission',
    whiteLabelCommission: 'Marginal på order från egen webshop (%)' || 'whiteLabelCommission',
    threasholdForDiscountedSupplierCommission: 'Gränsvärde för storköp (exklusive pant och moms)' ||
        'threasholdForDiscountedSupplierCommission',
    largeOrderDiscount: 'Rabatt på leverantörs kommission vid storköp (procentenheter)' ||
        'largeOrderDiscount',
    exactaFreightCostPerKg: 'exacta: fraktkostnad per kg' || 'exactaFreightCostPerKg',
    exactaHandlingCostPerColli: 'Hanteringskostnad per DFP för Systembolaget' ||
        'exactaHandlingCostPerColli',
    vindenHandlingCostPerColli: 'Hanteringskostnad per DFP från Webblager' || 'vindenHandlingCostPerColli',
    freightDiscountPercentage: 'Rabatterad distribution från Webblager (%)' || 'freightDiscountPercentage',
    taxWarehouseNumberAtVinden: 'Eget punktskattenummer hos vinden (om skiljt från flaivys) (13tecken)' ||
        'taxWarehouseNumberAtVinden',
    active: 'Aktiverad' || 'active',
    prognosisOrderCount: 'Prognos antal order per 12 månader' || 'prognosisOrderCount',
    prognosisRevenue: 'Prognos omsättning per 12 månader' || 'prognosisRevenue',
    email: 'E-post' || 'email',
    customerNumberInFortnox: 'Kundnummer i Flaivys Fortnox' || 'customerNumberInFortnox',
    settlementPeriod: 'Avräkningsperiod' || 'settlementPeriod',
    settlementPeriods: {
        weekly: 'varje vecka' || 'weekly',
        monthly: 'varje månad' || 'monthly',
        fullAndHalfMonth: 'hel och halv månad' || 'fullAndHalfMonth',
    },
    sendSettlementAutomatically: 'Skicka avräkningar automatiskt' || 'sendSettlementAutomatically',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
};
